import React from 'react';
import { Card, CardBody, ModalBody } from 'shards-react';

interface ModalEditBodyDeleteProps {
  description: string;
  label: string;
  name: string;
}

const ModalEditBodyDelete = ({ description, label, name }: ModalEditBodyDeleteProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log();
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ModalBody>
      <Card theme="danger" className="mb-3">
        <CardBody className="text-white">{description}</CardBody>
      </Card>
      <p className="mb-0">
        {label}：{name}
      </p>
    </ModalBody>
  );
};

export default ModalEditBodyDelete;
